import type { SWRConfiguration } from 'swr';

/**
 * Global SWR configuration.
 * - refreshInterval: 5 phút (300 000 ms) — đồng bộ với KV TTL backend
 * - revalidateOnFocus: refetch khi tab được focus lại
 * - revalidateOnReconnect: refetch khi kết nối mạng được khôi phục
 * - focusThrottleInterval: tối thiểu 60 giây giữa hai lần revalidate do focus
 * - dedupingInterval: loại bỏ request trùng trong 2 giây
 *
 * Requirements: 9.5, 9.6
 */
const swrConfig: SWRConfiguration = {
  refreshInterval: 300_000,       // 5 phút
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  focusThrottleInterval: 60_000,  // 60 giây
  dedupingInterval: 2_000,
};

export default swrConfig;
